import React from "react";
import { CameraIcon, ChevronRightIcon } from "/src/helpers/components/upsellIcons.jsx";

// "What's next to plan?" banner (prototype upsell-sections.jsx PlanBanner): hero image ·
// icon+title+desc · price + CTA. Excursions are orange-tinted, car hire blue-tinted, so the two
// banners read as deliberately different offers. On mobile the grid stacks and the CTA column
// becomes a bottom row (price left, button right).
const KINDS = {
    excursion: {
        soft: "bg-[#fff8ee]",
        border: "border-[#f4dfb8]",
        divider: "border-[#f4dfb8]",
        accent: "bg-[#f3941f] hover:bg-[#e08812]",
        icon: <CameraIcon size={26} />,
    },
    car: {
        soft: "bg-[#f0f7fd]",
        border: "border-[#cfe5f7]",
        divider: "border-[#cfe5f7]",
        accent: "bg-emp hover:bg-emp_dark",
        icon: (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <path d="M5 11.5 6.2 8a2.5 2.5 0 0 1 2.35-1.65h6.9A2.5 2.5 0 0 1 17.8 8L19 11.5a2 2 0 0 1 1.5 1.94V16a1 1 0 0 1-1 1h-.6a2.1 2.1 0 0 1-4.06 0H9.16a2.1 2.1 0 0 1-4.06 0H4.5a1 1 0 0 1-1-1v-2.56A2 2 0 0 1 5 11.5Zm1.9-.5h10.2l-.82-2.45a.9.9 0 0 0-.83-.55h-6.9a.9.9 0 0 0-.83.55Zm.35 3.1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm9.5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" />
            </svg>
        ),
    },
};

export default function PlanBanner({
    kind, img, title, desc, note,
    priceLabel = "From", price, priceUnit,
    cta, expandedLabel, onClick, expanded = false,
}) {
    const k = KINDS[kind] || KINDS.excursion;
    return (
        <div className={`grid grid-cols-1 md:grid-cols-[18.75rem_1fr_16.25rem] gap-3.5 md:gap-6 items-stretch rounded-card p-4 border ${k.soft} ${k.border}`}>
            <div className="rounded-xl overflow-hidden bg-[#0e2533] aspect-video md:aspect-[16/11]">
                <img src={img} alt="" className="w-full h-full object-cover block" />
            </div>

            <div className="flex flex-col justify-center py-2 min-w-0">
                <div className="flex items-center gap-3.5 mb-3.5">
                    <div className={`w-12 h-12 rounded-xl ${k.accent} flex items-center justify-center shrink-0 text-white`}>
                        {k.icon}
                    </div>
                    <h3 className="text-2xl font-poppins font-bold text-primary leading-tight">{title}</h3>
                </div>
                <p className="text-[0.9375rem] text-content_2 leading-normal max-w-[22.5rem]">{desc}</p>
                {note && <p className="text-xs text-content_3 mt-1">{note}</p>}
            </div>

            <div className={`flex flex-row md:flex-col items-center justify-between md:justify-center gap-3.5 md:gap-4
                             border-t md:border-t-0 md:border-l ${k.divider} pt-4 md:pt-2 md:pb-2 md:px-1`}>
                {price != null && (
                    <div className="text-left md:text-center leading-tight shrink-0">
                        <div className="text-[0.8125rem] text-content_3">{priceLabel}</div>
                        <div className="text-[2rem] font-extrabold text-primary my-0.5">{price}</div>
                        <div className="text-[0.8125rem] text-content_3">{priceUnit}</div>
                    </div>
                )}
                <button onClick={onClick}
                        className={`flex-1 md:flex-none md:w-full md:max-w-[13.75rem] px-5 py-[0.8125rem] rounded-[0.6875rem] text-white font-bold text-[0.9375rem]
                            ${k.accent} flex items-center justify-center gap-2 cursor-pointer transition-colors`}>
                    {expanded ? (expandedLabel || "Hide") : cta}
                    <ChevronRightIcon size={17} className={`transition-transform duration-200 ${expanded ? "rotate-90" : ""}`} />
                </button>
            </div>
        </div>
    );
}
